module.exports = __webpack_public_path__ + "static/media/22ESCWA6.0006c74c.jpg";